export const randomString = (len) => {
    len = len || 12;
    const chars = 'ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
    const maxPos = chars.length;
    let randomString = '';
    for (let i = 0; i < len; i++) {
      randomString += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return randomString;
}
export const imgUploadUrl = "https://upload-z2.qiniup.com";